module.exports = __webpack_public_path__ + "static/img/contentLeftImg6.b5a63c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentLeftImg6.png
// module id = O3n3
// module chunks = 2